import moment, { Moment } from 'moment';

import { CardCommentType, CardLinkPreviewType, CardReactionType, CardType, UserType } from "@/common/interfaces";
import { Column } from './board';
import { Ref, ref } from 'vue';

export default class Card {
	text: {[key: string]: any};
	readonly uuid: string;
	renderedText: string;
	createdAt: Moment;
	updatedAt: Moment;
	column: Column;
	creator: UserType; //TODO Use a user store eventually
	index: number;
	pinned: boolean;

	reactions: Array<CardReactionType>;

	votes: Array<[string, string]>;

	comments: Array<CardCommentType>;

	linkPreviews: Array<CardLinkPreviewType>;

	constructor(cardInfo: CardType, column: Column) {
		this.creator = cardInfo.creator;
		this.text = JSON.parse(cardInfo.text);
		this.uuid = cardInfo.uuid;
		this.renderedText = cardInfo.renderedText;
		this.createdAt = moment(cardInfo.createdAt);
		this.updatedAt = moment(cardInfo.updatedAt);
		this.index = cardInfo.index
		this.pinned = cardInfo.pinned;

		this.votes = [...cardInfo.votes];

		this.comments = [...cardInfo.comments];

		this.linkPreviews = [...cardInfo.linkPreviews];

		this.reactions = [...cardInfo.reactions];

		this.column = column;
	}

	update(cardInfo: CardType): void {
		if (cardInfo.uuid !== this.uuid) {
			return;
		}

		this.text = JSON.parse(cardInfo.text);
		this.renderedText = cardInfo.renderedText;
		this.updatedAt = moment(cardInfo.updatedAt);
		this.pinned = cardInfo.pinned;
	}

	changeColumn(newColumn: Column): void {
		if (newColumn.uuid === this.column.uuid) {
			return;
		}

		this.column = newColumn;
	}

	addVote(voterUuid: string, voteDateStr: string): void {
		const exists = this.votes.filter(
			(vi: [string, string]) => vi[0] === voterUuid
		);

		if (exists.length) {
			return;
		}

		this.votes.push([voterUuid, voteDateStr]);
	}

	removeVote(voterUuid: string): void {
		const index = this.votes.findIndex(
			(vi: [string, string]) => vi[0] === voterUuid
		);

		if (index < 0) {
			return;
		}

		this.votes.splice(index, 1);
	}

	removeLinkPreview(linkPreviewId: number): void {
		const index = this.linkPreviews.findIndex(
			(lp: CardLinkPreviewType) => lp.id === linkPreviewId
		);

		if (index < 0) {
			return;
		}

		this.linkPreviews.splice(index, 1);
	}

	addComment(comment: CardCommentType): void {
		this.comments.push(comment);
	}

	updateComment(updatedComment: CardCommentType): void {
		const comment = this.comments.find(
			(c: CardCommentType) => c.uuid === updatedComment.uuid
		);

		if (comment === undefined) {
			return;
		}

		comment.text = updatedComment.text;
		comment.renderedText = updatedComment.renderedText;
		comment.updatedAt = updatedComment.updatedAt;
		//comment.editedBy = updatedComment.editedBy
		//comment.editedOn = updatedComment.editedOn
	}

	removeComment(commentUuid: string): void {
		const index = this.comments.findIndex(
			(c: CardCommentType) => c.uuid === commentUuid
		);

		if (index < 0) {
			return;
		}

		this.comments.splice(index, 1);
	}

	getUserReaction(emoji: string, userUuid: string): CardReactionType | null {
		const reaction = this.reactions.find(
			(reaction: CardReactionType) => reaction.emoji === emoji
		);

		if (reaction === undefined) {
			return null;
		}

		const userIndex = reaction.users.findIndex(
			(ru: UserType) => ru.uuid === userUuid
		);

		if (userIndex < 0) {
			return null;
		}

		return reaction;
	}

	getReaction(emoji: string): CardReactionType | null {
		const reaction = this.reactions.find(
			(reaction: CardReactionType) => reaction.emoji === emoji
		);

		if (reaction === undefined) {
			return null;
		}

		return reaction;
	}

	addReaction(reaction: CardReactionType): void {
		const index = this.reactions.findIndex(
			(exreaction: CardReactionType) => exreaction.emoji === reaction.emoji
		);

		if (index < 0) {
			this.reactions.push(reaction);
			return;
		}

		this.reactions.splice(index, 1, reaction);
	}

	removeReaction(emoji: string, userUuid: string): void {
		const reactionIndex = this.reactions.findIndex(
			(reaction: CardReactionType) => reaction.emoji === emoji
		);

		if (reactionIndex < 0) {
			return;
		}

		const reaction = this.reactions[reactionIndex];

		if (reaction === undefined) {
			return;
		}

		const userIndex = reaction.users.findIndex(
			(ru: UserType) => ru.uuid === userUuid
		);

		if (userIndex < 0) {
			return;
		}

		if (reaction.users.length === 1) {
			this.reactions.splice(reactionIndex, 1);
			return;
		}

		reaction.users.splice(userIndex, 1);
		reaction.count -= 1;
	}
}
